import { useEffect, useState } from 'react';
import MyButton from '../../../UI/myButton/MyButton';
import AutocompleteMulti from '../../../UI/AutocompleteMulti';
import OInput from '../../../UI/FormControls/OInput';
import { formatDateBody } from '../../../../../utils/FormatDate';
import styles from './ZaglavljeFilter.module.css';
import useHttp from '../../../../hooks/use-http';
import { useTranslation } from 'react-i18next';
import { urls } from '../api/urls';

const ZaglavljeFilter = ({
  filterValues,
  setFilterValues,
  handlePretrazi,
  vratiGridPonude,
}) => {
  const { getData: vratiStatuseData } = useHttp('');
  const [statusiData, setStatusiData] = useState([]);
  const { t, i18n } = useTranslation();

  const vratiStatuseMulti = async () => {
    const result = await vratiStatuseData({
      url: urls.GET_STATUSI_COMBO,
      method: 'POST',
      data: { metadata: i18n.language },
    });

    if (result.length > 0) {
      setStatusiData(result);
      vratiGridPonude([]);
      setFilterValues((curr) => {
        return { ...curr, statusPonude: [] };
      });
    }
  };

  useEffect(() => {
    vratiStatuseMulti();
  }, [i18n.language]);

  const handleChange = (e) => {
    setFilterValues((curr) => {
      return { ...curr, [e.target.name]: e.target.value };
    });
  };

  const handleClickStatus = (e) => {
    setFilterValues((curr) => {
      return { ...curr, statusPonude: e };
    });
  };
  return (
    <div className={styles.container}>
      <OInput
        label={t('startDate')}
        style={{ width: '200px' }}
        handleChange={handleChange}
        type="date"
        value={formatDateBody(filterValues.datumOd)}
        name="datumOd"
      />
      <OInput
        label={t('endDate')}
        style={{ width: '200px' }}
        handleChange={handleChange}
        type="date"
        value={formatDateBody(filterValues.datumDo)}
        name="datumDo"
      />
      <AutocompleteMulti
        options={statusiData}
        value={filterValues.statusPonude}
        textProperty="vrednost"
        onChange={handleClickStatus}
        text="Status"
        style={{ maxWidth: '500px' }}
      />
      <MyButton
        onClick={handlePretrazi}
        label={t('search')}
        icon="fas fa-search"
      />
    </div>
  );
};

export default ZaglavljeFilter;
